import React from 'react';
import { Box, Button, Divider, DownloadIcon, RayIcon, Text } from '@razorpay/blade/components';
import { PolicySummaryProps } from './types';

export const PolicySummary = ({ policySummary, policyDocumentUrl }: PolicySummaryProps) => {
  if (!policySummary || policySummary.length === 0) return null;

  return (
    <Box
      width="380px"
      height="100%"
      borderLeftWidth="thin"
      borderColor="surface.border.gray.subtle"
      backgroundColor="surface.background.gray.moderate"
      display="flex"
      flexDirection="column"
      flexShrink={0}>
      <Box
        padding="spacing.7"
        display="flex"
        flexDirection="column"
        gap="spacing.4"
        flex="1"
        overflowY="auto">
        <Box display="flex" alignItems="center" gap="spacing.3">
          <RayIcon color="surface.icon.primary.normal" />
          <Text size="small" weight="semibold" color="surface.text.gray.normal">
            Policy Summary
          </Text>
        </Box>
        <Box display="flex" flexDirection="column">
          {policySummary.map((item, idx) => (
            <React.Fragment key={item.label}>
              <Box paddingY="spacing.3">
                <Text size="small" weight="semibold" color="surface.text.gray.subtle">
                  {item.label}
                </Text>
                <Text size="small" color="surface.text.gray.muted" marginTop="spacing.1">
                  {item.value}
                </Text>
              </Box>
              {idx < policySummary.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </Box>
      </Box>
      {policyDocumentUrl && (
        <Box padding="spacing.7" paddingTop="spacing.4">
          <Button
            variant="tertiary"
            icon={DownloadIcon}
            iconPosition="left"
            size="small"
            isFullWidth
            onClick={() => window.open(policyDocumentUrl, '_blank', 'noopener,noreferrer')}>
            Download Policy Document
          </Button>
        </Box>
      )}
    </Box>
  );
};
